// Canonical public origin baked in at build time (see REACT_APP_DEPLOY_ORIGIN in CI).
// Must match backend/config/deploy.js default and backend/.env DEPLOY_ORIGIN.
export const DEPLOY_ORIGIN =
  process.env.REACT_APP_DEPLOY_ORIGIN || 'https://jao7pfi9yg.com'

// Match backend wwwCanonicalRedirect. Returns a replacement href, or null.
export function canonicalHref(href) {
  const current = new URL(href)
  const canonical = new URL(DEPLOY_ORIGIN)
  if (current.hostname.toLowerCase() !== `www.${canonical.hostname}`) return null
  current.protocol = canonical.protocol
  current.hostname = canonical.hostname
  current.port = ''
  return current.href
}
